import { breakpoints, lockScroll } from '../utils';
import Hammer from 'hammerjs';

const setSlideAsActive = ($slide) => {
    const $gallery = $slide.parents('[data-product-gallery]');
    const $activeSlide = $gallery.find('[data-gallery-slide][data-active="1"]');
    const $activeThumb = (
        $gallery.find('[data-gallery-thumb-slide][data-active="1"]')
    );
    const $zoomOverlay = $('[data-zoom-overlay]');
    const $slideImage = $slide.find('img');
    const usesThumbnails = (
        $gallery.find('[data-gallery-thumb-slide]').length > 0
    );
    const index = $slide.index();

    $activeSlide.removeAttr('data-active');
    $slide.attr('data-active', 1);

    if ($slideImage.length > 0) {
        $zoomOverlay.find('img').remove();
        $zoomOverlay.append($slideImage.clone());
    }

    if (usesThumbnails) {
        $activeThumb.removeAttr('data-active');
        $gallery
            .find('[data-gallery-thumb-slide]')
            .eq(index)
            .attr('data-active', 1);
    }
};

const scrollToActive = ($gallery, smooth = true) => {
    const $slider = $gallery.find('[data-gallery-slider]');
    const $thumbSlider = $gallery.find('[data-gallery-thumb-slider]');
    const $activeSlide = $gallery.find('[data-gallery-slide][data-active="1"]');
    const $leftControl = $gallery.find('[data-gallery-control-left]');
    const $rightControl = $gallery.find('[data-gallery-control-right]');
    const $currentPage = $gallery.find('[data-gallery-current-page]');
    const $progress = $gallery.find('[data-gallery-progress]');
    const $zoomControl = $('[data-gallery-zoom]');
    const $slideVideo = $activeSlide.find('video');

    if ($activeSlide.length === 0) return;

    const index = $activeSlide.index();
    const slideCount = $gallery.find('[data-gallery-slide]').length;
    const newLeft = $activeSlide.position().left;

    $slider.get(0).scrollTo({
        left: Math.round(newLeft),
        behavior: smooth ? 'smooth' : 'instant',
    });

    if ($slideVideo.length > 0) {
        const video = $slideVideo.get(0);

        if ($(window).outerWidth() >= breakpoints.lg) {
            $zoomControl.css('display', 'none');
        }

        video.currentTime = 0;
        video.play();
        video.addEventListener('timeupdate', function() {
            if (this.currentTime > this.duration - 0.5) {
                this.pause();
            }
        });
    } else {
        $zoomControl.css('display', '');
    }

    $currentPage.text(index + 1);

    $progress.css('width', ((index + 1) / slideCount) * 100 + '%');

    if ($thumbSlider.length > 0) {
        const newThumbLeft = (
            $gallery
                .find('[data-gallery-thumb-slide][data-active="1"]')
                .position()
                .left
        );
        $thumbSlider.get(0).scrollTo({
            left: Math.round(newThumbLeft),
            behavior: smooth ? 'smooth' : 'instant',
        });
    }

    if (!$gallery.is('[data-loop]')) {

        if (index === 0) {
            $leftControl.attr('disabled', '');
        }
        else if (index === slideCount - 1) {
            $rightControl.attr('disabled', '');
        }
        else {
            $leftControl.removeAttr('disabled');
            $rightControl.removeAttr('disabled');
        }
    }
};

const goToNextSlide = ($gallery) => {
    const slideCount = $gallery.find('[data-gallery-slide]').length;
    const $activeSlide = (
        $gallery.find('[data-gallery-slide][data-active="1"]')
    );
    const index = $activeSlide.index();
    const nextIndex = (index === slideCount - 1) ? 0 : index + 1;

    const $nextSlide = $gallery.find('[data-gallery-slide]').eq(nextIndex);

    setSlideAsActive($nextSlide);

    scrollToActive($gallery);
};

const goToPreviousSlide = ($gallery) => {
    const slideCount = $gallery.find('[data-gallery-slide]').length;
    const $activeSlide = (
        $gallery.find('[data-gallery-slide][data-active="1"]')
    );
    const index = $activeSlide.index();
    const previousIndex = (index === 0) ? slideCount - 1 : index - 1;

    const $previousSlide = (
        $gallery.find('[data-gallery-slide]').eq(previousIndex)
    );

    setSlideAsActive($previousSlide);

    scrollToActive($gallery);
};

const initialize = () => {

    $('[data-product-gallery] [data-gallery-control-left]').click(function(e) {
        e.preventDefault();
        const $gallery = $(this).parents('[data-product-gallery]');
        goToPreviousSlide($gallery);
    });

    $('[data-product-gallery] [data-gallery-control-right]').click(function(e) {
        e.preventDefault();
        const $gallery = $(this).parents('[data-product-gallery]');
        goToNextSlide($gallery);
    });

    $('[data-product-gallery]').each(function() {

        const $gallery = $(this);

        let autoplay = null;
        let paused = false;
        const autoplayDelay = 2000;

        const handleSwipeGestures = () => {
            $gallery.find('img, video, a').attr('draggable', 'false');
            const swiper = new Hammer($gallery.get(0));
            swiper.on('swipeleft', function(e) {
                if (
                    !$gallery
                        .find('[data-gallery-control-right]')
                        .attr('disabled')
                ) {
                    clearInterval(autoplay);
                    goToNextSlide($gallery);
                }
            });
            swiper.on('swiperight', function(e) {
                if (
                    !$gallery
                        .find('[data-gallery-control-left]')
                        .attr('disabled')
                ) {
                    clearInterval(autoplay);
                    goToPreviousSlide($gallery);
                }
            });
        };

        const startAutoplay = () => {
            paused = false;
            autoplay = (
                setInterval(
                    () => {
                        if (!paused) {
                            goToNextSlide($gallery);
                        }
                    },
                    autoplayDelay
                )
            );

            $gallery
                .mouseover(() => paused = true)
                .mouseout(() => paused = false);

            $gallery
                .find('[data-gallery-control-left], [data-gallery-control-right]')
                .click(() => clearInterval(autoplay));
        };

        const handleScrollIntoView = () => {

            const observer = (
                new IntersectionObserver(
                    () => {
                        if (
                            $gallery.is('[data-autoplay]')
                            && autoplay === null
                        ) {
                            startAutoplay();
                        }
                    },
                )
            );

            observer.observe($gallery.get(0));
        };

        if ($gallery.find('[data-gallery-slide]').length > 2) {
            setSlideAsActive($gallery.find('[data-gallery-slide]').first());
        }

        $gallery.find('[data-gallery-thumb-slide]').click(function() {
            const index = $(this).index();
            setSlideAsActive(
                $gallery.find('[data-gallery-slide]').eq(index)
            );
            scrollToActive($gallery);
        });

        $gallery.find('[data-gallery-zoom]').click(function(e){
            e.preventDefault();
            $('[data-zoom-overlay]').addClass('active');
            lockScroll();
        });

        $gallery.find('[data-gallery-num-pages]').text(
            $gallery.find('[data-gallery-slide]').length
        );

        handleSwipeGestures();

        handleScrollIntoView();

        scrollToActive($gallery);
    });

    $(window).resize(() => {
        $('[data-product-gallery]').each(function() {
            setTimeout(() => {
                scrollToActive($(this));
            }, 300);
        });
    });
};

export default {
    initialize,
};

